import React, { useState } from 'react';
import MDBox from 'components/MDBox';
import { makeStyles } from '@mui/styles';
import DataTable from 'examples/Tables/DataTable'

const EntityAddressItemSelectDataTable = ({rowData, selectedRows, setSelectedRows}) => {
  const useStyles = makeStyles({
    root: {
      '& .MuiDataGrid-row.Mui-selected': {
        backgroundColor: 'rgba(0, 0, 255, 0.3)', // Customize selected row background color
      },
      '& .MuiDataGrid-row.Mui-selected:hover': {
        backgroundColor: 'rgba(0, 0, 255, 0.3)', // Keep the same background color on hover
      },
      '& .MuiDataGrid-row:hover': {
        backgroundColor: 'rgba(0, 0, 255, 0.04)', // Customize background color on hover
      },
      '& .MuiDataGrid-cell:focus-within': {
        outline: 'none', // Remove outline on cell focus
      },
    },
  });
  const classes = useStyles();

  const [searchQuery, setSearchQuery] = useState('');

  // const filteredRows = rowData.filter((row) =>
  //   row.Entity?.name.toLowerCase().includes(searchQuery.toLowerCase())
  // );
  const filteredRows = rowData.filter((row) => {
    // Convert searchQuery to lowercase for case-insensitive comparison
    const searchLower = searchQuery.toLowerCase();

    // Check if any property value in any cell of the row matches the search query
    return Object.values(row).some((cellValue) => {
        // If cellValue is an object, extract its string representation for comparison
        if (typeof cellValue === 'object' && cellValue !== null) {
            cellValue = Object.values(cellValue).join(' ');
        }
        // Check if the cellValue exists, is a string, and includes the search query (case-insensitive)
        return cellValue && typeof cellValue === 'string' && cellValue.toLowerCase().includes(searchLower);
    });
  });

  const columns = [
    {
      field: "address_item_id",
      accessor: "address_item_id",
      headerName: "Entity Address Item ID",
      Header: "Entity Address Item ID",
      flex: 1,
    },
    {
      field: "Icon.icon_name",
      accessor: "Icon.icon_name",
      headerName: "Icon",
      Header: "Icon",
      flex: 1,
      Cell: (info) => {
        return <i className={`${info.cell.row.original.Icon?.class_name}`} style={{ fontSize: "24px" }}></i> 
      },
    },
    {
      field: "name",
      accessor: "name",
      headerName: "Item Name",
      Header: "Item Name",
      flex: 1,
      valueGetter: (params) => params.row?.name,
    },
    {
      field: "Item.name",
      accessor: "Item.name",
      headerName: "Item Type Name",
      Header: "Item Type Name",
      flex: 1,
      valueGetter: (params) => params.row.Item?.name,
    },
    {
      field: "Entity.name",
      accessor: "Entity.name",
      headerName: "Entity Name",
      Header: "Entity Name",
      flex: 1,
      Cell: (info) => {
        const entityName = info.cell.row.original.Entity?.name;
        const firstName = info.cell.row.original.Entity?.first_name;
        const lasttName = info.cell.row.original.Entity?.last_name;
        // Check if Entity.name is empty or null, then use first_name
        return !["", null, undefined].includes(entityName) ? entityName : firstName + " " + lasttName;
      },
    },
    {
      field: "Address.name",
      accessor: "Address.name",
      headerName: "Address Name",
      Header: "Address Name",
      flex: 1,
      valueGetter: (params) => params.row.Address?.street_address1,
    },
    {
      field: "Address.street_address1",
      accessor: "Address.street_address1",
      headerName: "Street Address",
      Header: "Street Address",
      flex: 1,
      valueGetter: (params) => params.row.Address?.street_address1,
    },
    {
      field: "Address.city",
      accessor: "Address.city",
      headerName: "City",
      Header: "City",
      flex: 1,
      valueGetter: (params) => params.row.Address?.city,
    },
    {
      field: "Address.state",
      accessor: "Address.state",
      headerName: "State",
      Header: "State",
      flex: 1,
      valueGetter: (params) => params.row.Address?.state,
    },
    // {
    //   field: "Address.country",
    //   accessor: "Address.country",
    //   headerName: "Country",
    //   Header: "Country",
    //   flex: 1,
    //   valueGetter: (params) => params.row.Address?.country,
    // },
    // {
    //   field: "Address.latitude",
    //   accessor: "Address.latitude",
    //   headerName: "Latitude",
    //   Header: "Latitude",
    //   flex: 1,
    //   valueGetter: (params) => params.row.Address?.latitude,
    // },
    // {
    //   field: "Address.longitude",
    //   accessor: "Address.longitude",
    //   headerName: "Longitude",
    //   Header: "Longitude",
    //   flex: 1,
    //   valueGetter: (params) => params.row.Address?.longitude,
    // },
  ];

  return (
    <MDBox display="flex" flexDirection="column">
      {/* <MDBox display="flex" justifyContent="right" alignItems="right">
        <TextField
          label="Search"
          variant="outlined"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </MDBox>
      <DataGrid
        className={classes.root}
        rows={filteredRows}
        columns={columns}
        onRowSelectionModelChange={handleRowSelection}
        selectionModel={selectedRows}
        getRowId={(row) => row.id}
        sx={{
          maxHeight: '70vh', // Limit the modal height to 80% of viewport height
        }}
      /> */}
      <DataTable table={{columns, rows: filteredRows}} selectedRows={selectedRows} setSelectedRows={setSelectedRows} isSelection={true} isMultiSelect={true} canSearch={true}/>
    </MDBox>
  );
};

export default EntityAddressItemSelectDataTable;
